import api from 'api';

export const loadMasterCampaigns = api(
  'GET /api/influencers-briefs/filters/master-campaigns'
);

export const loadApplications = api(
  'GET /api/influencers-briefs/filters/applications'
);
